  export const setVideosLibraryData = (value) => {
    return {
      type: "SET_VIDEOS_LIBRARY_DATA",
      payload: { data: value },
    };
  };
  export const setVideosLibraryDataCount = (value) => {
    return {
      type: "SET_VIDEOS_LIBRARY_DATA_COUNT",
      payload: { data: value },
    };
  };
  export const setSelectedVideo = (value) => {
    return {
      type: "SET_SELECTED_VIDEO",
      payload: { data: value },
    };
  };

export const setSelectedInstructionVideos = (value) => {
  return {
    type: "SET_SELECTED_INSTRUCTION_VIDEOS",
    payload: { data: value },
  };
};

export const clearSelectedInstructionVideos = () => {
  return {
    type: "CLEAR_SELECTED_INSTRUCTION_VIDEOS",
    payload: { data: [] },
  };
};

export const setPagination = (pagination) => {
 return {
    type: "SET_VIDEOS_PAGINATION",
    payload: { data: pagination },
  };
}